<template>
	<el-dialog title="选择批改" center :visible="show" @close="close">
		<div class="p_flex p_f_c small_hand">
			<div @click="goTopic">
				<div class="box_img ">
					<img src="../../../../assets/img/zuoye.png" >
				</div>
				<span class="p_flex type_size_18 p_m_t_14">按题目批改</span>
			</div>
			<div class="p_m_l_60" @click="goPupil">
				<div class="box_img ">
					<img src="../../../../assets/img/xueshneg.png" >
				</div>
				<span class="p_flex type_size_18 p_m_t_14">按学生批改</span>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props:{
		show:null,
		id:null
	},
	data() {
		return {
			count:10,
			loading: false
		};
	},
	
	mounted() {
	},
	methods: {
		close() {
			this.$emit('closes', false);
		},
		goTopic(){
			this.$router.push({
				path:'/Topic',
				query: {
					id:this.id
				}
			});
		},
		goPupil(){
			this.$router.push({
				path:'/Pupil', 
				query: {
					id:this.id
				}
			});
		}
	}
};
</script>

<style lang="scss">
	.content_box{
		padding: 20px 0;
	}
	.subject_red{
		color: #F1282E;
	}
	.box_img{
		width: 54px;
		height: 66px;
		margin: 0 auto;
	}
	.box_img img{
		width: 100%;
		height: 100%;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/homet/correct/commponents/popUp.vue